import * as React from 'react';
import { Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import PartnerEpicClient from 'bundles/epic/clients/Partner';
import InstructorProfileViewer from 'bundles/partners-graphql/components/InstructorProfileViewer';
import PartnerApp from 'bundles/partners-graphql/components/PartnerApp';
import PartnerPage from 'bundles/partners-graphql/components/PartnerPage';
import PartnerPageCds from 'bundles/partners-graphql/components/cds/PartnerPage';
import PartnerListingPage from 'bundles/partners-graphql/components/listing/PartnerListingPage';
import PartnerListingPageCds from 'bundles/partners-graphql/components/listing/cds/PartnerListingPage';

const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const PartnerListingPageWithEpic = (props: { countryCode: string }) => {
  const enableRedesign = PartnerEpicClient.preview('enablePartnerPageRedesign');
  return enableRedesign ? <PartnerListingPageCds {...props} /> : <PartnerListingPage {...props} />;
};

const PartnerPageWithEpic = (props: { params: { shortName: string } }) => {
  const enableRedesign = PartnerEpicClient.preview('enablePartnerPageRedesign');
  return enableRedesign ? <PartnerPageCds {...props} /> : <PartnerPage {...props} />;
};

export default (
  <Route name="app" component={PartnerApp} path="/">
    <Route component={InstructorProfileViewer} path="/instructor/:instructorSlug" />
    <Route component={PartnerListingPageWithEpic} path="/partners" />
    <Route component={PartnerPage} path="/about/partners/preview/:shortName" />
    <Route component={PartnerPageWithEpic} path="/partners/:shortName" />
    <Route path="*" getComponent={NotFound} />
  </Route>
);
